import React from 'react';

import { useBulkImportWarningModal } from './useBulkImportWarningModal';

export function withBulkImportWarningModal<P>(
  WrappedComponent: React.ComponentType<
    P & {
      getBaseWarningModalProps: ReturnType<
        typeof useBulkImportWarningModal
      >['getBaseWarningModalProps'];
    }
  >,
) {
  return function BulkImportWarningModalWrapper(props: P) {
    const { getBaseWarningModalProps } = useBulkImportWarningModal();

    return (
      <WrappedComponent
        {...props}
        getBaseWarningModalProps={getBaseWarningModalProps}
      />
    );
  };
}
